import React from "react";
import { List, Accordion, Typography, AccordionDetails } from "@mui/material";

import { ListItem } from "./list-item";
import { AccordionSummary } from "./styles";

export type RenderItemInfo = { index: number; category: string };

type RenderItem = (props: RenderItemInfo) => React.ReactNode;

interface Props {
  selected: string[];
  disabled?: string[];
  renderPrimary: RenderItem;
  renderSecondary: RenderItem;
  data: { category: string; items: string[] }[];
  onSelectCategory: (category: string) => void;
  onSelect: (props: { category: string; index: number }) => void;
}

export const CheckboxList = ({
  data,
  selected,
  onSelect,
  renderPrimary,
  disabled = [],
  renderSecondary,
  onSelectCategory,
}: Props) => {
  const renderAllButtonItem = React.useCallback(
    (category: string) => {
      const items = data.find((i) => i.category === category)?.items ?? [];

      if (items.length > 1) {
        const isSelected = () => {
          return (
            selected.filter((item) => items.includes(item)).length ===
            items.length
          );
        };

        return (
          <ListItem
            primary="All"
            checked={isSelected()}
            secondary="Select all items"
            onClick={() => onSelectCategory(category)}
          />
        );
      }

      return null;
    },
    [data, onSelectCategory, selected]
  );

  return (
    <>
      {data.map((item, index) => (
        <Accordion
          square
          elevation={0}
          disableGutters
          style={{ width: "400px" }}
          key={`tag-manager-accordion-${item.category}-${index}`}
        >
          <AccordionSummary>
            <Typography>{item.category}</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ padding: 0 }}>
            <List sx={{ width: "100%" }}>
              {renderAllButtonItem(item.category)}

              {item.items.map((value, i) => {
                const primary = renderPrimary({
                  index: i,
                  category: item.category,
                }) as string;

                const secondary = renderSecondary({
                  index: i,
                  category: item.category,
                });

                return (
                  <ListItem
                    primary={primary}
                    secondary={secondary}
                    key={`${item.category}-${value}`}
                    checked={selected.includes(value)}
                    disabled={disabled?.includes(value)}
                    onClick={() =>
                      onSelect({ category: item.category, index: i })
                    }
                  />
                );
              })}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
